module.exports = __webpack_public_path__ + "img/burbujas-creditu.fe79312e.svg";